import styled from 'styled-components';

export const Heros = styled.div`
  display: flex;
  margin-top: 20px;
  height: auto;
  gap: 4%;

  @media (min-width: 1024px) {
    width: 38.7%;
    margin-left: 2px;
    margin-top: 0;
    min-height: 532px;
  }
`;
